module.exports = __webpack_public_path__ + "img/bank-17-dgb.5837d857.svg";